module.exports = __webpack_public_path__ + "img/bgs-scene-ship4.b315eccf.png";